import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4C5 2.89543 5.89543 2 7 2H19.7574C20.2878 2 20.7965 2.21071 21.1716 2.58579L26.4142 7.82843C26.7893 8.2035 27 8.71221 27 9.24264V28C27 29.1046 26.1046 30 25 30H7C5.89543 30 5 29.1046 5 28V4Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <rect opacity="0.5" x="10" y="19" width="9" height="2" rx="1" fill="#0090FF" />
      <rect opacity="0.5" x="10" y="23" width="12" height="2" rx="1" fill="#0090FF" />
      <path
        opacity="0.5"
        d="M13.4603 13.4603L11.5 11.5C11.2239 11.2239 11.2239 10.7761 11.5 10.5C11.7761 10.2239 12.2239 10.2239 12.5 10.5L13.4308 11.4308C13.469 11.469 13.531 11.469 13.5692 11.4308L14.5 10.5C14.7761 10.2239 15.2239 10.2239 15.5 10.5C15.7761 10.7761 15.7761 11.2239 15.5 11.5L13.5397 13.4603C13.5178 13.4822 13.4822 13.4822 13.4603 13.4603Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
    </svg>
  );
};

export default Svg;
